import { useCallback } from 'react';

import download from '~extension/icon-library/utils/downloadUrl';
import { DownloadIcon } from '../../icons/DownloadIcon';

type DownloadVarProps = { icon: Icon };
export const DownloadVar = ({ icon }: DownloadVarProps) => {
  return (
    <>
      {(icon.variations || []).map(variation => (
        <DownloadIconVariation key={variation.id} iconVariation={variation} />
      ))}
    </>
  );
};

const DownloadIconVariation = ({ iconVariation }: { iconVariation: IconVariation }) => {
  const { title, extension, downloadUrl, fileName } = iconVariation;

  const handleOnClick = useCallback(() => {
    download(downloadUrl, fileName);
  }, [downloadUrl, fileName]);

  return (
    <div className={`group flex items-center justify-between py-1 select-none cursor-pointer`} onClick={handleOnClick}>
      <div className={`flex justify-center opacity-50`}>
        <span className={`mx-2`}>{extension}</span>
      </div>
      <div className={`flex flex-grow justify-start overflow-hidden`} title={title}>
        <span className={`whitespace-nowrap overflow-ellipsis overflow-hidden group-hover:underline`}>{title}</span>
      </div>
      <div className={`flex items-center justify-center opacity-20 group-hover:opacity-100 transition-opacity`}>
        <span className={`h-5 w-5 mx-2`}>
          <DownloadIcon />
        </span>
      </div>
    </div>
  );
};
